var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 2.58008C20.163 2.58008 20.7989 2.84347 21.2678 3.31231C21.7366 3.78115 22 4.41704 22 5.08008V20.0801C22 20.7431 21.7366 21.379 21.2678 21.8478C20.7989 22.3167 20.163 22.5801 19.5 22.5801H4.5C3.83696 22.5801 3.20107 22.3167 2.73223 21.8478C2.26339 21.379 2 20.7431 2 20.0801V5.08008C2 4.41704 2.26339 3.78115 2.73223 3.31231C3.20107 2.84347 3.83696 2.58008 4.5 2.58008H19.5ZM10 4.58008H6C5.46957 4.58008 4.96086 4.79079 4.58579 5.16586C4.21071 5.54094 4 6.04965 4 6.58008V18.5801C4 19.1105 4.21071 19.6192 4.58579 19.9943C4.96086 20.3694 5.46957 20.5801 6 20.5801H10C10.5304 20.5801 11.0391 20.3694 11.4142 19.9943C11.7893 19.6192 12 19.1105 12 18.5801V6.58008C12 6.04965 11.7893 5.54094 11.4142 5.16586C11.0391 4.79079 10.5304 4.58008 10 4.58008Z",
    fill: "#6C7275"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggler);
export default __webpack_public_path__ + "static/media/toggler.3f4415340a5520c2899788ef8dcb7634.svg";
export { ForwardRef as ReactComponent };